import { GetterTree } from "vuex";
import { State } from "./state";

export default {
  practices: (state: State) => state.practices,
  practiceCount: (state: State) => state.practiceCount,
  dropdownPracticeList: (state: State) => state.dropdownPracticeList
} as GetterTree<State, any>;